import {
  time,
  Scheduler,
  Entity,
  coreEngine,
} from "@dinahmoe/dmafjs-core";

class PropertyTransform extends Entity {
  namespace = "control:property:transform";

  init(node) {
    node.complete = new Scheduler(this, this.onComplete.bind(this, node));
  }

  execute(node, config, event) {
    // change in v20, untested
    node.props = config;

    this.log("property:transform", event.name);
    node.complete.clear();

    let delay = node.props["timing.delay"] || 0;
    let startTime = event.time + delay;

    if (startTime < time.current) {
      startTime = time.current;
    }
    let endTime = startTime + node.props["timing.duration"];

    const propertyUid = node.props["target.property"];
    const dotIndex = propertyUid.indexOf(".");
    const nodeUid = propertyUid.slice(0, dotIndex);
    const propertyKey = propertyUid.slice(dotIndex + 1);
    coreEngine.update({
      uid: nodeUid,
      key: "transform",
      value: { transforms: [{
        property: propertyKey,
        valueStart: node.props["target.valueStart"],
        valueEnd: node.props["target.valueEnd"],
        duration: node.props["timing.duration"],
        delay: node.props["timing.delay"],
        easing: node.props["timing.easing"],
        curve: node.props["timing.curve"],
      }] },
    });
    node.complete.schedule(endTime, endTime);
  }

  onComplete(node, endTime) {
    const eventName = `${node.uid}:complete`;
    this.dispatch(eventName, endTime);
  }
}

const propertyTransform = new PropertyTransform();
export { propertyTransform, PropertyTransform };
